(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/falcon-bridge/assets/javascripts/falcon.js') >= 0) return;  svs.modules.push('/components/ticketgames/falcon-bridge/assets/javascripts/falcon.js');
"use strict";


var falcon;
(function (falcon) {
  var game;
  (function (game) {
    var bridge;
    (function (bridge) {
      var helper;
      (function (helper) {
        'use strict';

        var FUNCTIONNAME_INITIALIZATION = '__init__';
        var FUNCTIONNAME_SETNOTIFIER = 'setNotifier';
        var REQUESTID_NOTIFICATION = -1;
        var HELPER_REGISTRY = {};
        var DEFAULT_WIDTH = 120;
        var DEFAULT_HEIGHT = 160;
        var POPUPWINDOW_FEATURES = 'menubar=no,toolbar=no,location=no,width=' + DEFAULT_WIDTH + ',height=' + DEFAULT_HEIGHT;
        var POPUPWINDOW_REPLACE = true;
        var ChannelNextIndex = 0;
        var NotifierProxy = function () {
          function NotifierProxy(bridgeWindow, origin) {
            this.bridgeWindow = bridgeWindow;
            this.origin = origin;
          }
          NotifierProxy.prototype.notifyGameModeChange = function (gameMode) {
            this.sendNotification('notifyGameModeChange', gameMode);
          };
          NotifierProxy.prototype.notifyHostInformationChange = function (hostInformation) {
            this.sendNotification('notifyHostInformationChange', hostInformation);
          };
          NotifierProxy.prototype.notifyLocaleInformationChange = function (localeInformation) {
            this.sendNotification('notifyLocaleInformationChange', localeInformation);
          };
          NotifierProxy.prototype.notifyPurseInformationChange = function (purseInformation) {
            this.sendNotification('notifyPurseInformationChange', purseInformation);
          };
          NotifierProxy.prototype.notifyUserInformationChange = function (userInformation) {
            this.sendNotification('notifyUserInformationChange', userInformation);
          };
          NotifierProxy.prototype.notifySoundStatus = function (soundEnabled) {
            this.sendNotification('notifySoundStatus', soundEnabled);
          };
          NotifierProxy.prototype.sendNotification = function (notificationType, data) {
            var notification = {
              type: notificationType,
              data: data
            };
            var proxyResponse = {
              result: notification,
              id: REQUESTID_NOTIFICATION
            };
            this.bridgeWindow.postMessage(proxyResponse, this.origin);
          };
          return NotifierProxy;
        }();
        var HelperImpl = function () {
          function HelperImpl(parameters) {
            var _this = this;
            this.bridgeWindow = null;
            this.bridgeFrame = null;
            this.channel = null;
            this.channelId = null;
            this.bridgeUrl = null;
            this.savedEmitEvent = null;
            this.notifierProxy = null;
            this.parentNode = null;
            this.parentNode = parameters.parentNode;
            this.bridgeWindow = parameters.bridgeWindow;
            this.channel = parameters.hostChannel;
            this.channelId = HelperImpl.generateChannelId();
            this.bridgeUrl = parameters.bridgeLocation + '?channel=' + this.channelId;
            if (parameters.crossDomain && parameters.crossDomain.authorizedHosts) {
              this.bridgeUrl += '&host-key=' + parameters.crossDomain.hostKey;
            }
            if (parameters.betId) this.bridgeUrl += '&betId=' + parameters.betId;
            if (parameters.skipRules) this.bridgeUrl += '&skipRules=' + !!parameters.skipRules;
            if (parameters.gameMode) this.bridgeUrl += '&gameMode=' + parameters.gameMode;
            if (parameters.lotteryChannel) this.bridgeUrl += '&lotteryChannel=' + parameters.lotteryChannel;
            if (parameters.platform) this.bridgeUrl += '&platform=' + parameters.platform;
            if (parameters.gameSpecificParameters) this.bridgeUrl += '&gameSpecificParameters=' + encodeURIComponent(JSON.stringify(parameters.gameSpecificParameters));
            if (parameters.language) this.bridgeUrl += '&language=' + parameters.language;
            if (parameters.theme) this.bridgeUrl += '&theme=' + parameters.theme;
            if (parameters.soundEnabled === false || parameters.soundEnabled) this.bridgeUrl += '&soundEnabled=' + (parameters.soundEnabled ? 'true' : 'false');
            HELPER_REGISTRY[this.channelId] = this;
            window.addEventListener('message', this._onMessageEvent = function (event) {
              return _this.onMessageEvent(event);
            });
            window.addEventListener('orientationchange', this._onOrientationChangeEvent = function (event) {
              return _this.onOrientationChangeEvent(event);
            });
            this.savedEmitEvent = this.channel.emitEvent;
            this.channel.emitEvent = function (eventType, eventData) {
              return _this.onEmitEvent(eventType, eventData);
            };
            if (this.isSelfWindow()) {
              return;
            }
            this.setBridgeWindow();
          }
          HelperImpl.prototype.setBridgeWindow = function () {
            if (this.hasParentNode()) {
              this.bridgeFrame = document.createElement('iframe');
              this.bridgeFrame.allowFullscreen = true;
              this.bridgeFrame.src = this.bridgeUrl;
              this.bridgeFrame.frameBorder = 'no';
              this.bridgeFrame.scrolling = 'no';
              this.bridgeFrame.style.width = '100%';
              this.bridgeFrame.style.height = '100%';
              var nodesToStyle = [this.bridgeFrame, this.parentNode, this.parentNode.ownerDocument.body, this.parentNode.ownerDocument.documentElement];
              for (var i = 0; i < nodesToStyle.length; i++) {
                nodesToStyle[i].style.width = '100%';
                nodesToStyle[i].style.height = '100%';
                nodesToStyle[i].style.margin = '0';
                nodesToStyle[i].style.padding = '0';
              }
              this.parentNode.appendChild(this.bridgeFrame);
              this.bridgeWindow = this.bridgeFrame.contentWindow;
              return;
            }
            this.bridgeWindow = window.open(this.bridgeUrl, 'fcgamebridge-' + this.channelId, POPUPWINDOW_FEATURES, POPUPWINDOW_REPLACE);
          };
          HelperImpl.prototype.close = function () {
            window.removeEventListener('message', this._onMessageEvent);
            window.removeEventListener('orientationchange', this._onOrientationChangeEvent);
            if (this.bridgeFrame) {
              this.bridgeFrame.parentNode.removeChild(this.bridgeFrame);
            } else if (this.bridgeWindow) {
              this.bridgeWindow.close();
            }
            delete HELPER_REGISTRY[this.channelId];
          };
          HelperImpl.prototype.onEmitEvent = function (eventType, eventData) {
            if (eventType === 'DIMENSIONS') {}
            return this.savedEmitEvent.apply(this.channel, [eventType, eventData]);
          };
          HelperImpl.prototype.onMessageEvent = function (event) {
            var proxyRequest = event.data;
            if (!proxyRequest || !proxyRequest.functionName) {
              return;
            }
            if (proxyRequest.channelId && proxyRequest.channelId !== this.channelId) {
              return;
            }
            var functionName = proxyRequest.functionName;
            if (functionName === FUNCTIONNAME_INITIALIZATION) {
              this.onInitializationEvent(event.origin, proxyRequest);
            } else if (functionName === FUNCTIONNAME_SETNOTIFIER) {
              this.onSetNotifierEvent(event.origin);
            } else if (functionName in this.channel) {
              this.onFunctionCallEvent(event.origin, proxyRequest, functionName);
            } else if (functionName) {
              console.error('attempting to call unknown or unimplemented host function ' + functionName, event);
            }
          };
          HelperImpl.prototype.onInitializationEvent = function (origin, proxyRequest) {
            var proxyInitializationResult = {
              type: this.channel.type,
              name: this.channel.name
            };
            this.sendResult(origin, proxyRequest, proxyInitializationResult);
          };
          HelperImpl.prototype.onFunctionCallEvent = function (origin, proxyRequest, functionName) {
            var _this = this;
            var result = this.channel[functionName].apply(this.channel, proxyRequest.parameters);
            if (result) {
              if (this.isPromise(result)) {
                var resultPromise = result;
                resultPromise.then(function (promiseResult) {
                  _this.sendResult(origin, proxyRequest, promiseResult);
                }).catch(function (e) {
                  _this.sendResult(origin, proxyRequest, e, true);
                });
              } else {
                this.sendResult(origin, proxyRequest, result);
              }
            }
          };
          HelperImpl.prototype.onSetNotifierEvent = function (origin) {
            this.notifierProxy = new NotifierProxy(this.bridgeWindow, origin);
            if (FUNCTIONNAME_SETNOTIFIER in this.channel) {
              this.channel.setNotifier(this.notifierProxy);
            }
          };
          HelperImpl.prototype.onOrientationChangeEvent = function (event) {
            var _this = this;
            if (!this.notifierProxy) {
              return;
            }
            this.channel.getHostInformation().then(function (hostInformation) {
              return _this.notifierProxy.notifyHostInformationChange(hostInformation);
            });
          };
          HelperImpl.prototype.sendResult = function (allowedHost, proxyRequest, result, error) {
            var _this = this;
            var post = function (data, err) {
              var proxyResponse = {
                result: data,
                id: proxyRequest.id,
                error: err
              };
              _this.bridgeWindow.postMessage(proxyResponse, allowedHost);
            };
            if (result !== null && typeof result === 'object' && 'then' in result) {
              return result.then(function (newResult) {
                return post(newResult);
              }).catch(function (e) {
                return post(e.message, true);
              });
            }
            post(result, error);
          };
          HelperImpl.prototype.isPromise = function (object) {
            return typeof object.then === 'function' && typeof object.catch === 'function';
          };
          HelperImpl.generateChannelId = function () {
            return '' + ++ChannelNextIndex;
          };
          HelperImpl.prototype.isSelfWindow = function () {
            return this.bridgeWindow === window;
          };
          HelperImpl.prototype.hasParentNode = function () {
            return !!this.parentNode;
          };
          return HelperImpl;
        }();
        var HelperFactoryImpl = function () {
          function HelperFactoryImpl() {}
          HelperFactoryImpl.prototype.openGame = function (parameters) {
            this.instance = new HelperImpl(parameters);
            return this.instance;
          };
          HelperFactoryImpl.prototype.closeGame = function () {
            this.instance.close();
          };
          return HelperFactoryImpl;
        }();
        helper.instance = new HelperFactoryImpl();
      })(helper = bridge.helper || (bridge.helper = {}));
    })(bridge = game.bridge || (game.bridge = {}));
  })(game = falcon.game || (falcon.game = {}));
})(falcon || (falcon = {}));
fcGameBridge = falcon.game.bridge.helper.instance;
setGlobal('svs.ticketgames.falconBridge.falcon', falcon.game.bridge.helper.instance);

 })(window);